var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#CCE213"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_12770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0903 26.4534H56.2723C55.4935 26.4534 54.8632 27.0836 54.8632 27.8625C54.8632 28.6413 55.4934 29.2715 56.2723 29.2715H59.0903C59.8691 29.2715 60.4994 28.6414 60.4994 27.8625C60.4993 27.0836 59.8691 26.4534 59.0903 26.4534ZM44.8516 21.5962L43.4426 18.7781C43.0918 18.0818 42.2482 17.8026 41.552 18.1479C40.8557 18.496 40.5736 19.3423 40.9218 20.0386L42.3308 22.8566C42.6785 23.5501 43.5205 23.835 44.2215 23.4868C44.9176 23.1387 45.1997 22.2924 44.8516 21.5962ZM54.0844 18.1479C53.3909 17.8026 52.542 18.0819 52.1938 18.7781L50.7847 21.5962C50.4366 22.2924 50.7187 23.1386 51.4149 23.4868C51.7492 23.6537 52.1361 23.6811 52.4906 23.5629C52.8451 23.4447 53.1382 23.1907 53.3056 22.8566L54.7146 20.0386C55.0627 19.3423 54.7806 18.496 54.0844 18.1479ZM39.364 26.4534H36.546C35.7672 26.4534 35.1369 27.0836 35.1369 27.8625C35.1369 28.6413 35.7671 29.2715 36.546 29.2715H39.364C40.1428 29.2715 40.7731 28.6414 40.7731 27.8625C40.7731 27.0836 40.1428 26.4534 39.364 26.4534ZM30.91 40.6376H25.2738C24.4957 40.6376 23.8647 41.2684 23.8647 42.0466V64.5909C23.8647 65.369 24.4956 65.9999 25.2738 65.9999H30.9099C31.688 65.9999 32.3189 65.3691 32.3189 64.5909V42.0466C32.3189 41.2684 31.6882 40.6376 30.91 40.6376ZM66.1074 44.3726C65.8589 42.1868 63.8171 40.6376 61.6172 40.6376H50.6321C51.5657 38.9659 52.0668 34.2378 52.0445 32.3064C52.0077 29.1094 49.3601 26.5474 46.163 26.5474H45.0003C44.2215 26.5474 43.5912 27.1775 43.5912 27.9564C43.5912 31.2147 42.3225 37.0958 39.9297 39.4887C38.3192 41.0992 36.9424 41.6828 35.137 42.585V63.7273C37.9011 64.6486 41.4105 66 46.7596 66H55.9767C59.0137 66 61.379 63.1872 60.2022 60.2154C61.9951 59.7269 63.3174 58.0826 63.3174 56.1369C63.3174 55.5878 63.2115 55.0622 63.0202 54.5792C66.0417 53.756 67.1538 50.0252 65.0567 47.6827C65.8272 46.822 66.252 45.6447 66.1074 44.3726Z",
    fill: "#157483"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_12770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(21 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.6592e46913b39efa8bb825d5c09d8787.svg";
export { ForwardRef as ReactComponent };